import http from './http'

class Settings {
  fetch () {
    return http.get('/settings')
  }

  bankAccount () {
    return http.get('/settings/bank_account')
  }

  save (payload) {
    return http.put('/settings', payload)
  }

  load () {
    return http.get('/publics/system_settings')
  }
}

export default new Settings()



// WEBPACK FOOTER //
// ./src/services/settings.js